import type { EligibleTrainingItemsVM } from "@academy-context/shared/domain/types/eligible-training-items";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const adminRetrieveEligibleTrainingItems = createApiThunk<EligibleTrainingItemsVM, string>(
  "admin/retrieveEligibleTrainingItems",
  async (studentId: string, { extra: { adminRepository } }) => {
    return adminRepository!.getEligibleTrainingItems(studentId);
  },
);
